import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Injectable } from '@angular/core';
import { Security } from './security';
import { Observable, of } from 'rxjs';


@Injectable()
export class SecurityGuard implements CanActivate {
  constructor( public security: Security) {}
  // canActivate = kann aufgerufen werden
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean>{
      // Return Observable<boolean>, Methode von Klasse Security
      return this.security.checkIfAllowed(next.data.code);
  }
}
